import { useAuth } from '@/hooks/useAuth'
import { usePlatformStore } from '@/stores/platformStore'
import { ToolNav } from './ToolNav'
import { SmithyHeader } from './SmithyHeader'
import { AuthGate } from '@/components/auth/AuthGate'
import { HomeLanding } from './HomeLanding'
import { ExMarkedTool } from '@/tools/exmarked/ExMarkedTool'
import { CastTool } from '@/tools/cast/CastTool'
import { FoundryTool } from '@/tools/foundry/FoundryTool'

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-forge-void flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="w-8 h-8 border-2 border-forge-ember border-t-transparent rounded-full animate-spin" />
        <p className="text-forge-ash text-xs tracking-[0.2em] uppercase">Initializing Smithy</p>
      </div>
    </div>
  )
}

export function PlatformShell() {
  const { session, isAuthLoading } = useAuth()
  const activeTool = usePlatformStore((s) => s.activeTool)

  if (isAuthLoading) return <LoadingScreen />
  if (!session) return <AuthGate />

  return (
    <div className="h-screen flex bg-forge-void overflow-hidden">
      <ToolNav />
      <div className="flex-1 flex flex-col overflow-hidden">
        <SmithyHeader />
        <main className="flex-1 overflow-hidden">
          {activeTool === 'home'     && <HomeLanding />}
          {activeTool === 'exmarked' && <ExMarkedTool />}
          {activeTool === 'cast'     && <CastTool />}
          {activeTool === 'foundry'  && <FoundryTool />}
        </main>
      </div>
    </div>
  )
}
